import AnswerSelectionComponent from '../Components/AnswerSelectionComponent';
import EsgAnswerComponent from '../Components/EsgAnswerComponent';
import EsgQuestionComponent from '../Components/EsgQuestionComponent';
import JsonReader from './JsonReader';

class FlatJsonReader extends JsonReader {
  title = 'Flat Json Structure';

  displayItems() {
    this.displayItem(this.json, 'initial');
  }

  /**
   * Displays a single item
   * @param {EsgItem[]} json
   * @param {string} itemId
   * @returns {string}
   */
  displayItem(json, itemId) {
    if (json[itemId].item.type !== 'answer' && json[itemId].item.type !== 'answer_numbers') {
      this._addContents(
        EsgQuestionComponent(
          json[itemId],
          this.renderEsgItemAnswers(json[itemId]),
          this.renderEsgItemAnswersDebug(json[itemId])
        )
      );
    }

    if (json[itemId].answers) {
      json[itemId].answers.map((answer) => this.displayItem(json, answer));
    }
  }

  /**
   * Renders all answers for a given EsgItem
   * @param {EsgItem} esgItem
   * @returns {string}
   */
  renderEsgItemAnswers(esgItem) {
    if (esgItem.answers) {
      return esgItem.answers
        .map((answerId) => AnswerSelectionComponent(this.json[answerId], esgItem))
        .join('');
    }
    return 'keine Antworten vorhanden';
  }

  /**
   *
   * Renders all answer debug information for a given EsgItem
   * @param {EsgItem} esgItem
   * @returns {string}
   */
  renderEsgItemAnswersDebug(esgItem) {
    if (esgItem.answers) {
      return esgItem.answers.map((answerId) => EsgAnswerComponent(this.json[answerId])).join('');
    }
    return 'keine Antworten vorhanden';
  }
}

export default FlatJsonReader;
